import Axios from 'axios';
import { Config } from '../apiRoutes';

import {
  ADD_INVENTORY_REQUESTED,
  ADD_INVENTORY_SUCCESS,
  ADD_INVENTORY_FAILURE,
  SUBTRACT_INVENTORY_REQUESTED,
  SUBTRACT_INVENTORY_SUCCESS,
  SUBTRACT_INVENTORY_FAILURE,
  SET_INVENTORY_REQUESTED,
  SET_INVENTORY_SUCCESS,
  SET_INVENTORY_FAILURE,
  SCAN_INVENTORY_REQUESTED,
  SCAN_INVENTORY_SUCCESS,
  SCAN_INVENTORY_FAILURE,
  ADD_PLACEHOLDER_ACTION,
  TRANSFER_INVENTORY_REQUESTED,
  TRANSFER_INVENTORY_SUCCESS,
  TRANSFER_INVENTORY_FAILURE,
  LOAD_SESSION_EVENTS,
  CLEAR_SESSION,
  CLEAR_ACTION,
  SAVE_SESSION_CSV_REQUESTED,
  SAVE_SESSION_CSV_SUCCESS,
  SAVE_SESSION_CSV_FAILURE,
} from '../types';

export const addInventoryRequested = () => {
  return {
    type: ADD_INVENTORY_REQUESTED
  }
};

export const addInventorySuccess = (payload, locationName) => {
  return {
    type: ADD_INVENTORY_SUCCESS,
    locationName: locationName,
    payload: payload
  }
};

export const addInventoryFailure = (error) => {
  console.log(error);

  return {
    type: ADD_INVENTORY_FAILURE,
    status: error.response?.status,
    error: error.response?.data
  }
};

export const subtractInventoryRequested = () => {
  return {
    type: SUBTRACT_INVENTORY_REQUESTED
  }
};

export const subtractInventorySuccess = (payload, locationName) => {
  return {
    type: SUBTRACT_INVENTORY_SUCCESS,
    locationName: locationName,
    payload: payload
  }
};

export const subtractInventoryFailure = (error) => {
  console.log(error);
  
  return {
    type: SUBTRACT_INVENTORY_FAILURE,
    status: error.response?.status,
    error: error.response?.data
  }
};

export const setInventoryRequested = () => {
  return {
    type: SET_INVENTORY_REQUESTED
  }
};

export const setInventorySuccess = (payload, locationName) => {
  return {
    type: SET_INVENTORY_SUCCESS,
    locationName: locationName,
    payload: payload
  }
};

export const setInventoryFailure = (error) => {
  console.log(error);
  
  return {
    type: SET_INVENTORY_FAILURE,
    status: error.response?.status,
    error: error.response?.data
  }
};


export const scanInventoryRequested = () => {
  return {
    type: SCAN_INVENTORY_REQUESTED
  }
};

export const scanInventorySuccess = (payload, locationName) => {
  return {
    type: SCAN_INVENTORY_SUCCESS,
    locationName: locationName,
    payload: payload
  }
};

export const scanInventoryFailure = (error) => {
  console.log(error);
  
  return {
    type: SCAN_INVENTORY_FAILURE,
    status: error.response?.status,
    error: error.response?.data
  }
};

// export const transferInventoryRequested = () => {
//   return {
//     type: TRANSFER_INVENTORY_REQUESTED
//   }
// }

// export const transferInventorySuccess = (payload) => {
//   return {
//     type: TRANSFER_INVENTORY_SUCCESS,
//     payload: payload
//   }
// };

// export const transferInventoryFailure = (error) => {
//   return {
//     type: TRANSFER_INVENTORY_FAILURE,
//     error: error
//   }
// };


export const saveSessionCsvRequested = () => {
  return {
    type: SAVE_SESSION_CSV_REQUESTED
  }
}

export const saveSessionCsvSuccess = () => {
  return {
    type: SAVE_SESSION_CSV_SUCCESS
  }
}

export const saveSessionCsvFailure = () => {
  return {
    type: SAVE_SESSION_CSV_FAILURE
  }
}



export const addPlaceholder = (barcode, actionType) => {
  return {
    type: ADD_PLACEHOLDER_ACTION,
    barcode: barcode,
    actionType: actionType
  }
}

export const setEvents = (events) => {
  return {
    type: LOAD_SESSION_EVENTS,
    events: events
  }
}

export const clearSessionActions = () => {
  return {
    type: CLEAR_SESSION
  }
}

export const clearAction = (actionId) => {
  return {
    type: CLEAR_ACTION,
    actionId: actionId
  }
}

export const addInventory = (shopUrl, payload, barcode, actionId, actionQuantity, location) => {
  return (dispatch) => {
    dispatch(addInventoryRequested());

    let endPoint = Config.baseUrl + Config.barcode + Config.addInventory;
    let headers = Object.assign(Config.headers);
    headers.payload = payload;
    headers.shop = shopUrl;

    return Axios.post(endPoint, { actionId: actionId, barcode: barcode, actionQuantity: actionQuantity, location: location.id } , { headers: headers })
      .then((response) => {
        dispatch(addInventorySuccess(response.data, location.name));
      })
      .catch((error) => {
        dispatch(addInventoryFailure(error));
        throw new Error(error);
      });
  }
}

export const subtractInventory = (shopUrl, payload, barcode, actionId, actionQuantity, location) => {
  return (dispatch) => {
    dispatch(subtractInventoryRequested());

    let endPoint = Config.baseUrl + Config.barcode + Config.subtractInventory;
    let headers = Object.assign(Config.headers);
    headers.payload = payload;
    headers.shop = shopUrl;

    return Axios.post(endPoint, { actionId: actionId, barcode: barcode, actionQuantity: actionQuantity, location: location.id } , { headers: headers })
      .then((response) => {
        dispatch(subtractInventorySuccess(response.data, location.name));
      })
      .catch((error) => {
        dispatch(subtractInventoryFailure(error));
        throw new Error(error);
      });
  }
}

export const setInventory = (shopUrl, payload, barcode, actionId, actionQuantity, location) => {
  return (dispatch) => {
    dispatch(setInventoryRequested());

    let endPoint = Config.baseUrl + Config.barcode + Config.setInventory;
    let headers = Object.assign(Config.headers);
    headers.payload = payload;
    headers.shop = shopUrl;

    return Axios.post(endPoint, { actionId: actionId, barcode: barcode, actionQuantity: actionQuantity, location: location.id } , { headers: headers })
      .then((response) => {
        dispatch(setInventorySuccess(response.data, location.name));
      })
      .catch((error) => {
        dispatch(setInventoryFailure(error));
        throw new Error(error);
      });
  }
}

export const scanInventory = (shopUrl, payload, barcode, actionId, location) => {
  console.log(location);

  return (dispatch) => {
    dispatch(scanInventoryRequested());

    let endPoint = Config.baseUrl + Config.barcode + Config.scanInventory;
    let headers = Object.assign(Config.headers);
    headers.payload = payload;
    headers.shop = shopUrl;

    return Axios.post(endPoint, { actionId: actionId, barcode: barcode, location: location.id } , { headers: headers })
      .then((response) => {
        dispatch(scanInventorySuccess(response.data, location.name));
      })
      .catch((error) => {
        dispatch(scanInventoryFailure(error));
        throw new Error(error);
      });
  }
}

// export const transferInventory = (shopUrl, payload, barcode, actionId, actionQuantity, fromLocation, toLocation) => {
//   return (dispatch) => {
//     dispatch(transferInventoryRequested());

//     let endPoint = Config.baseUrl + Config.barcode + Config.transferInventory;
//     let headers = Object.assign(Config.headers);
//     headers.payload = payload;
//     headers.shop = shopUrl;

//     return Axios.post(endPoint, { actionId: actionId, barcode: barcode, actionQuantity: actionQuantity, from_location: fromLocation, to_location: toLocation } , { headers: headers })
//       .then((response) => {
//         dispatch(transferInventorySuccess(response.data));
//       })
//       .catch((error) => {
//         dispatch(transferInventoryFailure(error.response.data));
//       });
//   }
// }

export const saveSessionCsv = (shopUrl, payload, csvData) => {
  return (dispatch) => {
    dispatch(saveSessionCsvRequested());

    let endPoint = Config.baseUrl + Config.liveSave;
    let headers = Object.assign(Config.headers);
    headers.payload = payload;
    headers.shop = shopUrl;

    return Axios.post(endPoint, { csvData: csvData } , { headers: headers })
      .then((response) => {
        dispatch(saveSessionCsvSuccess());
      })
      .catch((error) => {
        dispatch(saveSessionCsvFailure());
        throw new Error(error);
      });
  }
}

export const addPlaceholderAction = (barcode, actionType) => {
  return (dispatch) => {
    dispatch(addPlaceholder(barcode, actionType));
  }
}

export const setEventsFromSession = (loadedSession) => {
  return (dispatch) => {
    dispatch(setEvents(loadedSession));
  }
}

export const clearActions = () => {
  return (dispatch) => {
    dispatch(clearSessionActions());
  }
}

export const dismissInventoryScan = (actionId) => {
  return (dispatch) => {
    dispatch(clearAction(actionId));
  }
}

